export enum ETipoRelatorio {
  CSV = '1',
  PDF = '2',
  XLSX = '3'
}
